module.exports = "<div [formGroup]=\"form\" class=\"form-group\">\n  <label *ngIf=\"inputType !== 'hidden'\" for=\"{{field}}\" class=\"col-sm-2 control-label\">{{displayName}}</label>\n  <div class=\"col-sm-10\">\n  <input [formControlName]=\"field\" type=\"{{inputType}}\" class=\"form-control\" [checked]=form.controls[field].value (change)=\"updateFormValue(form.controls[field].value)\">\n  <p class=\"text-muted\" *ngIf=\"inputType === 'datetime-local'\">timezone offset: {{adminService.tzOffsetInHours}}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/formcontrol-input/formcontrol-input.component.html
// module id = 301
// module chunks = 0 1